/**
 * An alternative to `$scope.$apply` that avoids triggering unnecessary $digests.
 * Sourced from:
 * https://github.com/wolfgangGoedel/observe-on-scope/blob/master/src/safeA
 pplyOnScope.ts.
 * TODO: Extract into `angular-common`.
 *
 * @param $scope
 * @returns {Function} Returns a function that can be used just like `$scope.$apply`.
 */
export const $applySmart = $scope => {
  return fn => {
    if ($scope.$$phase || ($scope.$root && $scope.$root.$$phase)) {
      fn();
    } else {
      $scope.$apply(fn);
    }
  };
};

/**
 * Convenience wrapper around `$applySmart` intended for use as event handlers.
 * Wraps an event handler function, running it within Angular's $digest cycle
 * when triggered.
 *
 * TODO: Extract into `angular-common`.
 *
 * @param $rootScope
 * @param $scope
 * @param handler {Function} Event handler to wrap.
 */
export const $applySmartEventHandler = ($scope, handler) => {
  const applySmart = $applySmart($scope);
  return event => applySmart(() => handler(event));
};
